import {BaseOptions} from "../../../../dialog/options/base.options";

export class ChairsOptions extends BaseOptions {
  spaceId?: any;
  businessId?: any;
}
